<div class="eftes-landing"
     [style.background-image]="'url(' + backgroundUrl + ')'">
  <div class="eftes-overlay"></div>


  <div class="hero-content">
    <h1 class="eftes-title">How a UK Hospital Uses Battery Storage to Optimise Energy Costs</h1>
    <p class="eftes-subtitle">
      Download the Industrial Flex case study and see how Bridlington Hospital uses battery storage to optimise tariffs and maximise solar self-consumption.
    </p>

    <div class="content-row">
      <div class="form-box">
        <ng-container *ngIf="!formularioEnviado">
          <h2 class="form-title">Get instant access</h2>

          <form [formGroup]="contactForm" (ngSubmit)="submit()" novalidate>
            <div class="field-wrap">
              <input type="text" formControlName="first_name" placeholder="FIRSTNAME" autocomplete="given-name">
              <span class="field-error" *ngIf="isSubmitted && contactForm.get('first_name').invalid">Required</span>
            </div>
            <div class="field-wrap">
              <input type="text" formControlName="surname" placeholder="LASTNAME" autocomplete="family-name">
              <span class="field-error" *ngIf="isSubmitted && contactForm.get('surname').invalid">Required</span>
            </div>
            <div class="field-wrap">
              <input type="email" formControlName="email" placeholder="EMAIL" autocomplete="email">
              <span class="field-error" *ngIf="isSubmitted && contactForm.get('email').invalid">Valid email required</span>
            </div>
            <div class="field-wrap">
              <input type="text" formControlName="telefono" placeholder="PHONE" autocomplete="tel">
              <span class="field-error" *ngIf="isSubmitted && contactForm.get('telefono').invalid">Required</span>
            </div>
            <div class="field-wrap">
              <input type="text" formControlName="company" placeholder="COMPANY" autocomplete="organization">
              <span class="field-error" *ngIf="isSubmitted && contactForm.get('company').invalid">Required</span>
            </div>

            <button type="submit" class="btn-download" [disabled]="formLoading">
              {{ formLoading ? 'Sending...' : 'Download case study' }}
            </button>

            <p class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</p>
          </form>
        </ng-container>

        <ng-container *ngIf="formularioEnviado">
          <h2 class="form-title">Thanks!</h2>
          <p class="thanks-msg">Your case study is ready.</p>
          <button class="btn-download" (click)="downloadFile()">Download</button>
        </ng-container>
      </div>

      <div class="info-panel">
        <p class="info-lead">See how a real UK healthcare site implemented 932 kWh of battery storage to improve energy management.</p>
        <p class="info-intro">Inside the case study:</p>
        <ul class="info-list">
          <li>Real project overview</li>
          <li>System configuration (Industrial Flex 2+3)</li>
          <li>Tariff optimisation &amp; solar self-consumption use case</li>
          <li>Commissioning &amp; safety highlights</li>
          <li>Key learnings for C&amp;I installers</li>
        </ul>
        <p class="info-cta">Complete the form to access the PDF.</p>
      </div>
    </div>
  </div>
</div>
